var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 387936593"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.5 3L10.5 6H12.75C12.75 8.48625 10.7362 10.5 8.25 10.5C7.48875 10.5 6.77625 10.3088 6.14625 9.97875L5.05125 11.0737C5.98125 11.655 7.0725 12 8.25 12C11.565 12 14.25 9.315 14.25 6H16.5L13.5 3ZM3.75 6C3.75 3.51375 5.76375 1.5 8.25 1.5C9.01125 1.5 9.72375 1.69125 10.3538 2.02125L11.4487 0.92625C10.5187 0.345 9.4275 0 8.25 0C4.935 0 2.25 2.685 2.25 6H0L3 9L6 6H3.75Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refreshIcon.33c5c0a5b33edb76ef6f2564ddc041a3.svg";
export { ForwardRef as ReactComponent };